import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Buttons/Table_Button";
import SidebarBOT from "../Sidebar/SidebarBOT";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../Utility/API";
import { updateAuth } from "../../Redux/AuthSlice";
import DOMPurify from "dompurify";
import Fleg from "../../Assets/Header/Flag.png";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
import toast from "react-hot-toast";

const HelpDeskBoat = () => {
  const [ReportApi, setReportApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(50);
  const [query, setQuery] = useState("");
  const [queryText, setText] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dash, setdataArray] = useState([]);
  const { userId, jwtToken } = useSelector((state) => state.Auth);

  const GetUserDetails = async () => {
    try {
      let responceDash = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 1,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      //console.log("responceDashboard", responceDash.data.data[0]);
      responceDash = responceDash.data.data[0];

      setdataArray(responceDash);
    } catch (e) {
      console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e?.response?.data?.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const Submit_API = async (event) => {
    event.preventDefault();
    try {
      if (query === "") {
        toast.error("Enter Your Subject !!");
        return;
      } else if (queryText === "") {
        toast.error("Enter Your Query !!");
        return;
      }
      let responce = await API.post(
        "HelpDesk",
        {
          uid: userId,
          query: query,
          querTypeText: queryText,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      //console.log("Submit-->", responce.data.data);
      if (responce.data.data == "Update Successfull") {
        toast.success("Query has been sent succrssfully !!");
        Report_API();
        setQuery("");
        setText("");
      } else {
        toast.error(responce.data.data);
      }
    } catch (e) {
      if (
        e.response.data.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            aexnglobalAuth: false,
            userId: null,
            jwtToken: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const Report_API = async () => {
    try {
      let responce = await API.post(
        "GetHelpdeskuser",
        {
          uid: userId,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      responce = responce.data.data[0];
      //console.log("res-->", responce);
      setReportApi([]);

      let arr = [];
      responce.forEach((item, index) => {
        arr.push({
          sr: index + 1,
          status:
            item.status == "open" ? (
              <span style={{ color: "red" }}>Open</span>
            ) : (
              <span style={{ color: "green" }}>Closed</span>
            ),
          edate: item.ee,
          subject: item.subject,
          reply_message: item.reply_message,
          ticket_id: item.ticket_id,
          query: item.query,
          rd: item.rd,
        });
      });

      setReportApi(arr);
    } catch (e) {
      if (
        e.response.data.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            aexnglobalAuth: false,
            userId: null,
            jwtToken: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };
  //Notification start
  // const [NotificationCount, setNotificationCount] = useState("");
  // const getNotification = async () => {
  //   try {
  //     let res = await API.get(`/GetNotificationuserCount?uid=${userId}`);
  //     setNotificationCount(res.data.data.result);
  //   } catch (e) {
  //     console.log("Error", e);
  //   }
  // }
  // Notification end

  useEffect(() => {
    Report_API();
    GetUserDetails();
    // getNotification();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPost = ReportApi.slice(indexOfFirstPage, indexOfLastPost);

  var [reportData, set_reportData] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "Ticket Id", accessor: "ticket_id" },
      { Header: "Subject", accessor: "subject" },
      { Header: "Query", accessor: "query" },
      { Header: "Query Date", accessor: "edate" },
      { Header: "Status", accessor: "status" },
      { Header: "Reply", accessor: "reply_message" },
      { Header: "Reply Date", accessor: "rd" },
    ],
  });

  function handleQuery(e) {
    const { value } = e.target;
    setQuery(DOMPurify.sanitize(value));
  }

  function handleQueryText(e) {
    const { value } = e.target;
    setText(DOMPurify.sanitize(value));
  }
  // Toggle sidebar function
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="container-fluid NewDashboard HelpDesk">
      <div className="row">
        <div
          className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
        >
          <SidebarBOT />
        </div>
        <div className="col-lg-2 px-0 order-2">
          <div className="sidebarLeft px-3 position-relative">
            <div className="leftisidelogo">
              <img className="h-100 w-100" src={logo} alt="" />
            </div>
            <ul className="itemssidebar">
            <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FIX Investment
                  </Link>
                  {dash?.Fixpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ALGO TRADING Investment
                  </Link>
                  {dash?.FixTradingpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ADV. TRADING Investment
                  </Link>
                  {dash?.FixAdvTradingpackage}
                </li>
              <li>
                <Link
                  to=""
                  className="Anker w-100"
                  id="txtchangevalue"
                  value="Withdrawal"
                  // onClick={() => OnHandleWithdrawalLink()}
                >
                  <div className="icon">
                    <img className="w-100 h-100" src={IconA} alt="" />
                  </div>{" "}
                  Total Income
                </Link>
                ${dash.TotalIncome}
              </li>
              <li>
                <Link
                  to=""
                  className="Anker w-100"
                  id="txtchangevalue"
                  value="Withdrawal"
                  // onClick={() => OnHandleWithdrawalLink()}
                >
                  <div className="icon">
                    <img className="w-100 h-100" src={IconA} alt="" />
                  </div>{" "}
                  Withdrawal Amount
                </Link>
                ${dash.WithDrawal_Amount}
              </li>
              <li>
                <Link className="Anker" to="">
                  <div className="icon">
                    <img className="w-100 h-100" src={IconA} alt="" />
                  </div>{" "}
                  Net Balance
                </Link>{" "}
                ${dash?.Net_Balance}
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-10 px-0 order-lg-2 order-1">
          <div className="contentside">
            <header className="header ps-0">
              <div className="hdleft d-flex align-items-center">
                <div className="namelogo ms-3">Raise A Query</div>
              </div>
              <div className="rightside">
                <div className="dropdown dropdow2 d-none d-md-block">
                  <Link
                    className="btn btnsecondary dropdown-toggle"
                    to=""
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="text1">
                      <p className="mb-1">ID Number</p>
                      <p className="mb-0 fw-bold text-start">{userId} </p>
                    </span>
                    <span className="icon">
                      <div className="name">
                        <img className="w-100 h-100" src={logo} alt="" />
                      </div>
                    </span>
                  </Link>

                  <ul className="dropdown-menu p-2">
                    <li className="text-white walltadd">{dash?.f_name}</li>
                  </ul>
                </div>
                <div className="dropdown dropdow2 d-block d-md-none">
                  <Link
                    className="btn btnsecondary dropdown-toggle"
                    to=""
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="icon">
                      <div className="name">
                        <img className="w-100 h-100" src={logo} alt="" />
                      </div>
                    </span>
                  </Link>

                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to="#">
                        Id Number <span>{userId}</span>
                      </Link>
                    </li>
                    <li className="text-white walltadd">{dash?.f_name}</li>
                  </ul>
                </div>
                <a href="/DashboardFIX">
                  <button className="btn headerbtn">FIX PLAN</button>
                </a>
                <button
                  className="btn border-0 togglebtn"
                  id="togglebtn"
                  onClick={toggleSidebar}
                >
                  <i
                    className={`fas fa-bars text-white ${
                      isSidebarOpen ? "" : "collapsed"
                    }`}
                  ></i>
                </button>
              </div>
            </header>
          </div>
          <div className="row mx-0">
            <div className="contentsidesec w-100 pt-3">
              <div className="row mx-0">
                <div className="col-xl-12">
                  <form onSubmit={Submit_API} id="queryForm">
                    <div className="bg pad-tp-15">
                      <label className="text-black">Subject</label>
                      <input
                        type="text"
                        className="floating-input select_bg"
                        id="Subject"
                        placeholder="Subject"
                        onChange={handleQuery}
                        value={query}
                      />
                    </div>
                    <div className="bg pad-tp-15">
                      <label className="text-black">Your Query</label>
                      <textarea
                        className="floating-input select_bg"
                        id="query"
                        rows={3}
                        value={queryText}
                        onChange={handleQueryText}
                      />
                      {/* <textarea
                            name="msg"
                            className="form-elm"
                            cols={30}
                            rows={5}
                            placeholder="Write Message"
                            required=""
                            defaultValue={""}
                          /> */}
                    </div>
                    {/* <div className="bg pad-tp-15">
                        <div className="flexbox">
                          <div className="flex-md-10">
                            <input
                              className="size-md"
                              type="checkbox"
                              name="terms"
                              required=""
                            />
                        </div>
                        <div className="flex-md-90">
                          <span>
                            I Accept all the terms of use, privacy policy. I Also
                            acknowledge that, Above information is accurate &amp;
                            authentic as per my current knowledge.
                          </span>
                        </div>
                      </div>
                    </div> */}
                    <div className="bg pad-tp-15 pad-bt-10">
                      <button type="submit" className="btn btn-primary mt_5">
                        Submit Query
                      </button>
                    </div>
                  </form>
                  <div className="break20" />
                </div>
                <div class="breadcrumb-header justify-content-between">
                  <div class="left-content">
                    <h1 class="main-content-title mg-b-0 mg-b-lg-1 text-black">
                      Query List
                    </h1>
                  </div>
                </div>
                <div className="bg">
                  <div className="bg pos-rel pad-bt-20 marg-bt-20 notfictiontextable">
                    <Table data={[...currentPost]} columns={reportData.cols} />
                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage}
                      indexOfLastPost={indexOfLastPost}
                      setcurrentPage={setcurrentPage}
                      currentPage={currentPage}
                      totalData={ReportApi.length}
                      listPerpage={listPerpage}
                      handleRowsPerPageChange={setlistPerpage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpDeskBoat;
